import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Funcionará si solo tengo Cuenta RUT?',
  answer: 'Sí. De hecho, enseñamos cómo usar las cuentas prepago (Tenpo, MACH) para proteger tu dinero del banco y evitar los descuentos automáticos que te dejan sin liquidez.'
}, {
  question: '¿Tengo que esperar años para que esto funcione?',
  answer: 'No. El blindaje de sueldo se aplica en 24 horas y los resultados de negociación suelen verse entre los 30 y 60 días, dependiendo de la agresividad con la que apliques las plantillas.'
}, {
  question: 'Ya me notificaron del juzgado, ¿aún sirve?',
  answer: 'Absolutamente. El capítulo de Receptores Judiciales te enseña qué hacer exactamente en ese momento crítico para proteger tus bienes y ganar tiempo valioso para negociar a tu favor.'
}];
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-4 bg-navy-800" data-id="element-43">
      <div className="max-w-3xl mx-auto" data-id="element-44">
        <div className="text-center mb-12" data-id="element-45">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-46">
            Preguntas Frecuentes
          </h2>
          <p className="text-gray-400" data-id="element-47">
            Resolvemos tus dudas antes de que tomes la decisión
          </p>
        </div>

        <div className="space-y-4" data-id="element-48">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-navy-900 border border-navy-700 rounded-xl overflow-hidden" data-id="element-49">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-50">
                <span className="font-bold text-white text-lg pr-4" data-id="element-51">
                  {faq.question}
                </span>
                <ChevronDown className={`text-gold-500 transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-52" />
              </button>

              <AnimatePresence data-id="element-53">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-54">
                    <div className="px-6 pb-5 text-gray-300 leading-relaxed border-t border-navy-800 pt-4" data-id="element-55">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}